import { Context } from '../context/Context';
import { Scene } from '../scene/Scene';
import { Camera } from '../camera';

export abstract class SceneRenderer {
  public abstract init(ctx: Context): void;

  public abstract destroy(): void;

  /** Recreate viewport-dependent FBOs after canvas resize. */
  public resize(): void {}


  public abstract render(scene: Scene, camera: Camera, buffer: WebGLFramebuffer | null): void;
}
